export type Placement = 'bottom' | 'top' | 'right' | 'left';

export type TooltipRenderPropsLike = {
  index: number;
  size: number;
  step: { content: React.ReactNode };
  backProps?: any;
  primaryProps?: any;
  closeProps?: any;
  skipProps?: any;
  isLastStep?: boolean;
  continuous?: boolean;
  tooltipProps?: any;
};

// Onboarding shared enums, constants, and types
export enum OnboardingStepKeyEnum {
  RiskMitigation = 'risk_mitigation',
  PmTools = 'pm_tools',
  ImportUsers = 'import_users',
  ImportTeams = 'import_teams',
  OrgSkills = 'org_skills',
  AllocateSkills = 'allocate_skills',
  OrgHolidays = 'org_holidays',
  Explore = 'explore',
  Integrations = 'integrations',
  SiltentIntegrations = 'silent_integrations',
  StrategyMap = 'strategy_map',
  InvitePeople = 'invite_people',
}

export const PMTOOLS_PROVIDER_ORDER = [ 'jira', 'asana', 'azure', 'monday', 'github', 'slack'] as const;
export type PmProviderKey = typeof PMTOOLS_PROVIDER_ORDER[number];

export const SKILLORG_PROVIDER_ORDER = ['skills_side_navigation', 'skills_settings_side_navigation', 'add_skill'] as const;
export type SkillOrgProviderKey = typeof SKILLORG_PROVIDER_ORDER[number];

export const RISK_MITIGATION_SUBSTEPS = ['awareness', 'analyze', 'prefill', 'send'] as const;
export type RiskSubKey = typeof RISK_MITIGATION_SUBSTEPS[number];

export type RoadmapStep = { key: OnboardingStepKeyEnum; done: boolean; include: boolean };
export type FlattenedStep = { key: OnboardingStepKeyEnum; provider?: PmProviderKey; riskSubKey?: RiskSubKey };

export type UseOnboardingStepOptions = {
  shouldShow?: boolean;
  providerKey?: 'jira' | 'asana' | 'azure' | 'monday' | 'github' | 'slack';
  riskSubKey?: RiskSubKey;
};

export type UseOnboardingStepReturn = {
  show: boolean;
  complete: () => Promise<void>;
  isCompleted: boolean;
}; 